import React, { useEffect } from 'react';
import { CheckIcon } from 'lucide-react';
import { DiamondIcon } from '../components/diamond/DiamondIcon';
import { useTallyLead } from '../hooks/useTallyLead';
export function Gracias() {
  useTallyLead();
  useEffect(() => {
    const previousTitle = document.title;
    document.title = '¡Recibimos tu solicitud! | JSEEFECT';
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex, nofollow';
    document.head.appendChild(robots);
    return () => {
      document.title = previousTitle;
      robots.remove();
    };
  }, []);
  return <div className="flex min-h-screen w-full flex-col bg-void font-sans text-white" data-id="element-320" data-mp="3kmj3oxzd37at">
      <header className="flex justify-center px-6 pt-8 sm:pt-10" data-id="element-321" data-mp="3fvsvlczjwqcf">
        <span className="flex items-center gap-2.5 text-sm font-semibold tracking-[0.4em] text-white" data-id="element-322" data-mp="3ftg7sj743lrg">
          <DiamondIcon className="h-4 w-4 text-white/80" data-id="element-323" data-mp="2s3lvq3uma189" />
          JSEEFECT
        </span>
      </header>

      <main className="flex flex-1 items-center justify-center px-5 py-16 sm:px-8" data-id="element-324" data-mp="2n512wphp2jtu">
        <div className="w-full max-w-xl overflow-hidden rounded-2xl border border-white/10 bg-[#1E1E24] text-center" data-id="element-325" data-mp="2galkzifmjbwb">
          <div className="h-0.5 w-full bg-[#FF101F]" aria-hidden="true" data-id="element-326" data-mp="2q2hjuvpjb61l" />
          <div className="px-6 py-12 sm:px-12 sm:py-16" data-id="element-327" data-mp="2q4lz29svvrh6">
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-[#FF101F]/50 bg-[#FF101F]/10" data-id="element-328" data-mp="2u4coa92rhzjl">
              <CheckIcon className="h-7 w-7 text-[#FF101F]" strokeWidth={2.5} aria-hidden="true" data-id="element-329" data-mp="1xfojieg248s4" />
            </span>
            <h1 className="mt-8 text-3xl font-extrabold tracking-tight sm:text-4xl" data-id="element-330" data-mp="22erlfq0qpyvv">¡Recibimos tu solicitud!</h1>
            <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-331" data-mp="2bdd2fgqkd5uj">
              Gracias por dar este primer paso con JSEEFECT. Pronto nos pondremos en contacto contigo para conversar
              sobre tus objetivos y tu asesoría gratuita.
            </p>
          </div>
        </div>
      </main>

      <footer className="px-6 pb-10 text-center text-xs text-white/40" data-id="element-332" data-mp="1mphcemv9gymc">
        <p data-id="element-333" data-mp="1ip72x089fq2q">© 2026 JSEEFECT. Todos los derechos reservados.</p>
      </footer>
    </div>;
}